export function capitalizeFirstLetter(string: string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

export const unmaskPhone = (maskedPhone: string): string => {
	if (!maskedPhone) {
		return '';
	}

	return maskedPhone.replace(/[^\d+]/g, '');
};

export const formatPhoneNumber = (phoneNumber: string) => {
	if (!phoneNumber) {
		return false;
	}

	phoneNumber = phoneNumber.replace(/\D/g, '');
	const formattedPhoneNumber = phoneNumber.replace(
		/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/,
		'+$1 ($2) $3-$4-$5',
	);
	return formattedPhoneNumber;
};
